export class LoginResult {
    public id: number;
    public fullName: string;
    public securityLevel: string;
    public personalPictureFileName: string;

    constructor() {
        this.id = 0;
        this.fullName = '';
        this.securityLevel = '';
        this.personalPictureFileName = '';
    }
}